import useSearchComicsRecomended from "@/api/hooks/useSearchComicsRecomended"
import Badge, { BadgeIconContent } from "@/components/shared/Badge"
import Card from "@/components/shared/Card"
import CardSkeleton from "@/components/shared/Card/CardSkeleton"
import Container from "@/components/shared/Container"
import RoundedButton from "@/components/shared/RoundedButton"
import Typography from "@/components/shared/Typography"
import { ROUTES } from "@/conf"
import Image from "next/image"
import { useParams, useRouter } from "next/navigation"
import { ComicState } from "swagger/models"

interface Props {
  gainedGroshaks: number
  comicsName: string
  comicsBackgroundImageUrl: string
}

const GameResultPage = ({ gainedGroshaks = 90, comicsBackgroundImageUrl, comicsName }: Props) => {
  const { comicsList, isLoading } = useSearchComicsRecomended(0, 3)

  const router = useRouter()
  const params = useParams()

  const getGroshaksString = () => {
    if (gainedGroshaks === 1) {
      return "grošák"
    } else if (gainedGroshaks > 1 && gainedGroshaks < 5) {
      return "grošáky"
    } else {
      return "grošáků"
    }
  }

  return (
    <>
      <div className="absolute left-0 top-0 h-full max-h-[522px] w-full max-w-[944px] before:absolute before:z-10 before:h-full before:w-full before:bg-gradient-to-r before:from-primary-700/0 before:from-0% before:to-primary-700 before:to-100% before:content-['_'] after:absolute after:z-10 after:h-full after:w-full after:bg-gradient-to-b after:from-primary-700/0 after:from-0% after:to-primary-700 after:to-100% after:content-['_'] lg:max-h-[560px]">
        <Image
          src={comicsBackgroundImageUrl}
          alt={comicsName}
          quality={100}
          sizes="100"
          fill
          className="object-cover"
        />
      </div>
      <Container className="relative z-20 pb-10 pt-20">
        <RoundedButton
          onClick={() => router.push(`${ROUTES.cartoonDetail}/${params.slug}`)}
          className="absolute left-6 top-8 z-20"
          icon={<Image src="/assets/images/arrow_left.svg" width={32} height={32} alt="" />}
        />
        <Image className="mx-auto" src="/assets/images/result_bg.png" alt="Resul glow" width={300} height={300} />
        <Typography type="h1" className="mb-20 text-center text-[#F9D760]">
          Vyhrál jsi
          <br /> {gainedGroshaks} {getGroshaksString()}.
        </Typography>
        <Typography className="mb-6 text-center" type="h2">
          Mohlo by se ti líbit
        </Typography>

        <div className="grid grid-cols-1 gap-4 pb-10 sm:grid-cols-2 md:grid-cols-3 lg:gap-6">
          <>
            {isLoading ? (
              Array(3)
                .fill("x")
                .map((_, idx) => {
                  return <CardSkeleton key={idx} />
                })
            ) : (
              <>
                {comicsList?.content.slice(0, 3).map((i) => {
                  return (
                    <>
                      <Card
                        title={i.name}
                        subtitle={i?.location?.name || ""}
                        link={`${ROUTES.cartoonDetail}/${i.slug}`}
                        image={i?.imageUrl || "/assets/images/cartoon.png"}
                        key={i.slug}
                        state={ComicState.READYTOPLAY}
                      >
                        <div className="absolute right-4 top-4 flex flex-col items-end justify-end">
                          <Badge className="mb-2" inverse>
                            <BadgeIconContent
                              crown={i?.game?.claimed}
                              location={i?.location?.claimed}
                              help={i?.bonusQuestion?.claimed}
                            />
                          </Badge>
                          <Badge
                            icon={<Image src="/assets/images/grosak.svg" width={20} height={20} alt="" />}
                            variant="reward"
                            inverse
                          >
                            {`${i.gainedGroshak} / ${i.maxOfGroshak}`}
                          </Badge>
                        </div>
                      </Card>
                    </>
                  )
                })}
              </>
            )}
          </>
        </div>
      </Container>
    </>
  )
}

export default GameResultPage
